import { DiariseOptionModel } from "../models/diarise-option.model";

export class DiariseWorkEvent {
    diariseOption: DiariseOptionModel
    diariseUntilDate: string; // dd/mm/yyyy
    diariseUntilHours:number; //24 hours
    diariseUntilMinutes:number;
    diariseTextReason: string;
    diariseReasonOption: string;
    menuData:any;
    source:string;

    // constructor(_diariseOption: DiariseOptionModel,_diariseUntilDate:string,_diariseUntilHours:number,_diariseUntilMinutes:number,_diariseReason:string)
    // {
    //     this.diariseOption = _diariseOption;
    //     this.diariseUntilDate =_diariseUntilDate;
    //     this.diariseUntilHours =_diariseUntilHours;
    //     this.diariseUntilMinutes =_diariseUntilMinutes;
    //     this.diariseTextReason = _diariseReason;
    // }
}